<template>
    
    <div class="column">
        
        <!-- IF Image -->
        <div 
            v-if="data.type === 'image'"
            class="image-container"
            ref="imageContainer"
            :style="{ paddingBottom: 'calc(' +padding+ '% - 1px )' }"
        >
            <image-loader
                :data="data.urls"
                :containerWidth="containerWidth"
                @loaded="onImageLoaded"
            />
        </div>
        
        <!-- IF Video -->
        <div 
            v-if="data.type === 'video'"
            class="video-container"
            ref="videoContainer"
            :style="{ paddingBottom: 'calc(' +padding+ '% - 1px )' }"
        >
            <video-loader
                ref="video"
                :data="data.urls"  
                :autoplay=true 
                :loop=true
                @loaded="onVideoLoaded"
            />
        </div>
    </div>
    
</template>


<script>
import ImageLoader from '@/components/ImageLoader'
import VideoLoader from '@/components/VideoLoader'
import Size from '@/plugins/WindowSize'

export default {
    
    props: {
        data: {
            type: Object,
            required: false,
        }
    },
    
    components: {
        ImageLoader,
        VideoLoader
    },

    
    data() {
        return {
            padding: 0,
            containerWidth: 0,
        }
    },
    
    created() {
        Size.addListener(this.onResize)
    },
    
    destroyed() {
        Size.removeListener(this.onResize)
    },
    
    mounted() {
        let as = this.data.aspectRatio.split(":")
        let w = as[0]
        let h = as[1]
        this.aspectRatio = h/w;
        
        this.onResize()
    },
    
    methods: {
        
        onEnter() {
            if (this.data.type === 'video') {
                this.$refs.video.play()
            }
        },
        onLeave() {
            if (this.data.type === 'video') {
                this.$refs.video.pause()
            }
        },
        onImageLoaded() {
            this.onLoaded()
        },
        onVideoLoaded() {
            this.onLoaded()
        },
        onLoaded() {
            this.$emit('loaded')
        },
        onResize() {
            if (this.$refs.imageContainer !== undefined) {
                this.containerWidth = this.$refs.imageContainer.offsetWidth
            }
            
            if (this.$refs.videoContainer !== undefined) {
                this.containerWidth = this.$refs.videoContainer.offsetWidth
            }
            
            var containerHeight = this.containerWidth*this.aspectRatio
            this.padding = (containerHeight / this.containerWidth) * 100        
        },
    },
    
    computed: {
        isCaseFullWidth() {
            return this.$store.state.isCaseFullWidth
        },
    },
    
    watch: {
        isCaseFullWidth() {
            // Transition is playing - Wait until animation is done before updating image size
            if (this.resizeTimer) {
                window.clearTimeout(this.resizeTimer);
            }
            this.resizeTimer = window.setTimeout(this.onResize, 650) // Animation takes 600ms
        },
    },
}

</script>


<style lang="scss" scoped>
@import '../scss/variables';

.column {
    .image-container,
    .video-container {
        height: 0;
        overflow: hidden;
        
        img,
        video {
            opacity: 0;
            transition: opacity 2s ease-out;

            &.loaded {
                opacity: 1;
            }
        }
    }
}

</style>
